module.exports = __webpack_public_path__ + "media/one-place.6924b315.webm";